import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { Analytics } from '@vercel/analytics/react';
import { store } from './store/store';
import App from './App';
import './styles/App.css';

// Sentry: logging de errores del frontend (opcional).
// Para activarlo: crear una cuenta gratis en https://sentry.io, crear un
// proyecto de React, y configurar la variable de entorno REACT_APP_SENTRY_DSN
// (por ejemplo en Vercel → Settings → Environment Variables). Sin esa
// variable, Sentry.init no hace nada dañino: no envía datos ni rompe nada.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    tracesSampleRate: 0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <p>Algo salió mal. Recargá la página o escribinos a support@tarotmistico.lat</p>
        </div>
      }
    >
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
      <Analytics />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
